var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("EmulatorSectionHeader", { attrs: { title: "Fonts" } }),
      _vm._l(_vm.fontGroups, function (group) {
        return _c(
          "div",
          { key: group.category },
          [
            _c("h4", { staticClass: "mt-4 mb-3" }, [
              _vm._v(_vm._s(group.category)),
            ]),
            _vm._l(group.fields, function (field) {
              return [
                field.inputType === "dropdown"
                  ? _c("EmulatorCustomizationDropdown", {
                      key: "dropdown-" + field.path,
                      attrs: {
                        category: group.category,
                        label: field.label,
                        namespace: "theme",
                        path: field.path,
                        dataType: "string",
                        options: _vm.fontNameList,
                        selectionChangedHandler: _vm.onFontCustomization,
                      },
                    })
                  : _c("EmulatorCustomizationTextBox", {
                      key: "textbox-" + field.path,
                      attrs: {
                        category: group.category,
                        label: field.label,
                        namespace: "theme",
                        path: field.path,
                        dataType: field.dataType,
                        placeholder: field.placeholder,
                      },
                    }),
              ]
            }),
          ],
          2
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }